<template>
    <div class="full-width-header">
        <shopTitle style="margin-bottom: 20px" v-show="useTitle !== false" />

        <shopPosition />

        <shopExpiration class="content-part-box" @click="goExp" />

        <shopInvition class="content-part-box" @goInvRecord="goInvRecord" />

<!--        <ShopAgent class="content-part-box" />-->

<!--        <PayMethodEditor  />-->

    </div>
</template>

<script setup>
import {getCurrentInstance, inject, ref} from "vue";
    import shopTitle from "@/components/shopopee/shop/shopTitle"
    import shopExpiration from "@/components/shopopee/shop/shopExpiration"
    import shopInvition from "@/components/shopopee/shop/shopInvition"
    import PayMethodEditor from "@/components/shopopee/company/payMethodEditor.vue";
    import ShopAgent from "@/components/shopopee/shop/shopAgent.vue";
    import shopPosition from "@/components/shopopee/shop/shopPosition"
    import myUtil from "@/util/util";
    const i18n = inject("i18n")

    const { proxy } = getCurrentInstance();

    const props = defineProps(["useTitle"])
    const emits = defineEmits(['goInvRecord'])

    const { goBillView } = inject('phoneView', { goBillView: () => { proxy.$router.push({name: "myBill"} )} })

    const ishOpen = ref("true")
    function goInvRecord() {
        emits("goInvRecord")
    }

    function goExp() {
        // myUtil.alertInfo("暫無賬單")
        // goBillView()
    }

</script>

<style scoped>
    .full-width-header {
        width: 100%;
        //border-radius: 5px;
        border-top: 1px #DCDFE6 solid;
        border-bottom: 1px #DCDFE6 solid;
        text-align: center;
        padding: 10px;
        box-sizing: border-box;
    }

    .content-part-box {
        margin-top: 20px;
    }
</style>